import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { forwardRef } from "react";
import { Button } from "@mantine/core";
import { usePrivy } from "@privy-io/react-auth";
import { SignIn } from "../../../../assets/icons.generated";
export const PrivySignInButton = forwardRef(({ children, ...rest }, ref) => {
    const { login } = usePrivy();
    return (_jsx(Button, { ref: ref, ...rest, leftIcon: _jsx(SignIn, {}), onClick: login, children: children }));
});
